export const STATUS = [
  {
    title: '全部',
    val: 0,
  },
  {
    title: '未开始',
    val: 1,
  },
  {
    title: '进行中',
    val: 2,
  },
  {
    title: '已过期',
    val: 3,
  },
  {
    title: '已下线',
    val: 4,
  },
];

export const STATUS_MAP = {};

function transformArr2Map(data = [], res = {}) {
  data.forEach((item) => {
    res[item.val] = item.title;
  });
}

transformArr2Map(STATUS, STATUS_MAP);
